export default "__VITE_ASSET__4f1ac169__"